if (typeof($add) == "undefined") var $add = {
    version: {},
    auto: {
        disabled: false
    }
};
! function(a) {
    $add.version.Tabs = "1.1.0", $add.Tabs = function(d, s) {
        return a(d).each(function(d, e) {
            var t = a(e),
                i = a.extend({
                    change: "click"
                }, t.data(), s),
                role_tabs = t.find("[role=tabs]");
            role_tabs.addClass("addui-Tabs-tabHolder");
            var c = role_tabs.children(),
                o = t.find("[role=contents]");
            o.addClass("addui-Tabs-contentHolder");
            var r = o.children(),
                u = 0;
            t.addClass("addui-Tabs").attr("role", "").removeAttr("role"), c.addClass("addui-Tabs-tab"), r.addClass("addui-Tabs-content").each(function(d, s) {
                a(s).hasClass("active") && (a(s).removeClass("active"), u = d)
            }), r.removeClass("addui-Tabs-active").eq(u).addClass("addui-Tabs-active"), c.removeClass("addui-Tabs-active").eq(u).addClass("addui-Tabs-active");
            var l = "click";
            "hover" == i.change && (l = "mouseenter"), c.on(l, function(a) {
                c.each(function(d, s) {
                    s == a.target && (u = d, r.removeClass("addui-Tabs-active").eq(u).addClass("addui-Tabs-active"), c.removeClass("addui-Tabs-active").eq(u).addClass("addui-Tabs-active"))
                })
            })
        }), this
    }, a.fn.addTabs = function(a) {
        $add.Tabs(this, a)
    }, $add.auto.Tabs = function() {
        $add.auto.disabled || a("[data-addui=tabs]").addTabs()
    }
}(jQuery);
$(function() {
    for (var k in $add.auto) {
        if (typeof($add.auto[k]) == "function") {
            $add.auto[k]();
        }
    }
});
